import get from "lodash/get";
import { toast } from "react-toastify";

function uuid() {
  return "ruid-xxxxxxxx-xxxx-4xxx-yxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function toInt(text) {
  return parseInt(text, 10);
}

/**
|--------------------------------------------------
| how to use: 
| import Lib from "utils/Lib.js"
|
| Lib.getNested(source-array, 'a.b.c.d', 'text if not found')
|--------------------------------------------------
*/
function getNested(source, path, def = "-") {
  return get(source, path, def);
}

/**
|--------------------------------------------------
| how to use: 
| import Lib from "utils/Lib.js"
|
| Lib.replaceEmpty(array-not-nested Eg:(PurchaseVendor), 'text if not found')
|--------------------------------------------------
*/
function replaceEmpty(arr, def = "-") {
  if (!arr || arr === "") {
    return def;
  } else {
    return arr;
  }
}

/**
|--------------------------------------------------
| Generate Data Source for Drawer detail.
|--------------------------------------------------
*/
function generateDSDrawer() {
  let ex = {
    drawerTitle: "nama asset"
  };

  return ex;
}

function confirm(p, timeout = 0) {
  return new Promise(resolve => {
    window._confirm.open({
      ...p,
      onConfirm: res => {
        setTimeout(resolve, timeout, res);
      }
    });
  });
}

function getAllMessage(obj) {
  let str = null;
  if (obj) {
    if (Array.isArray(obj)) {
      str = [];
      for (let i = 0; i < obj.length; i++) str.push(getAllMessage(obj[i]));
      str = str.join("\n");
    } else if (typeof obj === "object") {
      str = [];
      for (const key in obj) str.push(`${key}: \n${getAllMessage(obj[key])}`);
      str = str.join("\n");
    } else {
      str = obj;
    }
    return str;
  } else {
    return "";
  }
}

function responseMessage(type = "error", message, options = {}) {
  toast[type](getAllMessage(message));
}

export default {
  uuid,
  toInt,
  getNested,
  replaceEmpty,
  generateDSDrawer,
  confirm,
  getAllMessage,
  responseMessage
};



// WEBPACK FOOTER //
// ./src/App/utils/Lib.js